import { RootState } from "../../../../../models";
import { RetailerFwaState } from "../../../../../models/state";

const getFwa = (state: RootState): RetailerFwaState | undefined => state.retailer?.fwa as RetailerFwaState | undefined;

export const getFwaCoverageStatus = (state: RootState) => getFwa(state)?.coverageStatus ?? "idle";
export const getFwaCoverageError = (state: RootState) => getFwa(state)?.coverageError;
export const getFwaPackages = (state: RootState) => getFwa(state)?.packages ?? [];
export const getFwaSelectedPackageId = (state: RootState) => getFwa(state)?.selectedPackageId ?? null;
export const getFwaValidAddressId = (state: RootState) => getFwa(state)?.validAddressId;
export const getIsTraadlosTabActive = (state: RootState) => getFwa(state)?.isTraadlosTabActive ?? false;
export const getFwaSelectedPackageDetails = (state: RootState) => getFwa(state)?.selectedPackageDetails;
export const getFwaSelectedPackage = (state: RootState) => {
    const fwa = getFwa(state);
    if (!fwa || fwa.selectedPackageId === null) return null;
    return fwa.packages.find((p) => p.id === fwa.selectedPackageId) ?? null;
};
